import React from 'react';
import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from 'recharts';

interface DonutChartProps {
  active: number;
  inactive: number;
  loading: boolean;
}

const numberFormatter = new Intl.NumberFormat('pt-BR');

const DonutChart: React.FC<DonutChartProps> = ({ active, inactive, loading }) => {
  const theme = useTheme();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 260 }}>
        <Skeleton variant="circular" width={200} height={200} />
      </Box>
    );
  }

  const total = active + inactive;

  if (total === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 260 }}>
        <Typography variant="body1" color="text.secondary">
          Sem dados
        </Typography>
      </Box>
    );
  }

  const activePct = total > 0 ? Math.round((active / total) * 100) : 0;
  const inactivePct = 100 - activePct;

  const data = [
    { name: `Ativos: ${numberFormatter.format(active)} (${activePct}%)`, value: active },
    { name: `Não ativos: ${numberFormatter.format(inactive)} (${inactivePct}%)`, value: inactive },
  ];

  const COLORS = [theme.palette.primary.main, theme.palette.grey[400]];

  return (
    <ResponsiveContainer width="100%" height={260}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={70}
          outerRadius={110}
          paddingAngle={2}
          dataKey="value"
        >
          {data.map((_, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          formatter={(value: any) => [numberFormatter.format(Number(value)), '']}
        />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default DonutChart;
